import { useProjectDetailsContext } from "pages/project/context/ProjectDetailsContext";
import RichTextDisplay from "components/common/RichTextDisplay";

function LabeledRow({ label, children }) {
  return (
    <div className="flex flex-wrap gap-x-2 text-sm leading-6">
      <span className="font-semibold text-text-900 shrink-0">{label}:</span>
      <span className="text-text-700">{children}</span>
    </div>
  );
}

function TeamMemberCard({ member, index }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm space-y-4">
      <div className="flex items-start gap-4">
        {member.imageUrl && (
          <img
            src={member.imageUrl}
            alt={member.name || `Team member ${index + 1}`}
            className="h-16 w-16 rounded-full object-cover shrink-0 border border-slate-200"
          />
        )}
        <div>
          <h4 className="text-base font-bold text-text-900">{member.name || "—"}</h4>
          {member.position && (
            <p className="text-sm text-text-600">{member.position}</p>
          )}
        </div>
      </div>

      <div className="space-y-1.5">
        {member.municipality && (
          <LabeledRow label="Municipality of Residence">{member.municipality}</LabeledRow>
        )}
        {member.email && (
          <LabeledRow label="Email Address">
            <a
              href={`mailto:${member.email}`}
              className="text-brand-700 underline hover:text-brand-900"
            >
              {member.email}
            </a>
          </LabeledRow>
        )}
        {member.occupation && (
          <LabeledRow label="Principal Occupation for the Last Five Years">
            {member.occupation}
          </LabeledRow>
        )}
      </div>

      {member.about && (
        <div>
          <p className="mb-1 text-sm font-semibold text-text-900">About:</p>
          <RichTextDisplay html={member.about} />
        </div>
      )}
    </div>
  );
}

export default function TeamInfoTab() {
  const { project } = useProjectDetailsContext();
  const members = Array.isArray(project?.teamMembers) ? project.teamMembers : [];

  if (!members.length) {
    return (
      <p className="mt-3 text-sm text-text-600">
        Leadership and core team information will appear in this section.
      </p>
    );
  }

  return (
    <div className="mt-3 space-y-4">
      {members.map((member, index) => (
        <TeamMemberCard key={member.email || index} member={member} index={index} />
      ))}
    </div>
  );
}
